<template>
	<div>
		<div class="row">
			<div class="col-8 mb-4">
				<h1>Crown Prep</h1>
				<p>During the assessment, the assessor will observe the individual's performance of the entire dental crown procedure: Preparation , Impressions, Crown fabrication, Cementation</p>
			</div>
		</div>
		<div class="row">
			<div class="col-8 mb-4">
				<div class="form-group" v-if="signers.length > 0">
					<label>{{ $t('approval-from') }}</label>
					<input
						type="text"
						:value="(signoffFrom?signoffFrom.title:null)"
						class="form-control"
						:class="{error:signoffFromError}"
						@focus="selectSignoff"
						:placeholder="$t('none')"
					/>
					<span class="text-error" v-if="signoffFromError">{{$t('select')}}</span>
				</div>

				<div class="form-group"  v-if="this.$config.getValue('workbooks').length">
					<label for="form">{{$t('workbooks')}}</label>
					<div class="clearfix">
						<div class="pseudo-input mb-4">
							<input
								type="search"
								class="input-bare w-full flex-1"
								:placeholder="$t('workbooks')"
								v-if="!workbooks.length"
								@click="openWorkbooksModal"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(workbook, index) in workbooks"
								v-bind:key="index"
							>
								{{ workbook.title }}
								<a @click="removeWorkbook(workbook)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="workbooks.length"
								@click="openWorkbooksModal"
							>
								<b-icon icon="plus"></b-icon> {{ $t('add') }}
							</span>
						</div>
					</div>
				</div>
				<button class="btn btn-primary float-right">{{ $t('next') }}</button>
        	</div>
        </div>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			forms: [],
			students: [],
			reviewers: [],
			signers: [],
			form: null,
			recipients: [],
			recipientsError: false,
			reviewFromError: false,
			usersubjectError: false,
			usersubject: {
				id: null,
				title: null
			},
			reviewFrom: {
				id: null,
				title: null
			},
			signoffFromError: false,
			signoffFrom: {
				id: null,
				title: null
			},
			workbooks: [],
			publicationDate: null,
			deadline: null,
			message: null
		}
	},
	mounted() {
		this.form = {
			id: 1
		}
		this.getSigners();
	},
	methods: {
		getSigners() {
			if(!this.form) {
				this.signers = [];
				return false;
			}
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectsignoffuser`, {
				data: {
					form_id: this.form.id
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.signers = json.users;
					if(this.isTeacher) {
						// preselect self in "approval from" field
						this.signoffFrom.id = this.$UserSession.getValue('id');
						this.signoffFrom.title = this.$UserSession.getValue('displayName');
					}
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		selectSignoff(){
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select'),
				selectCallback: function(selection) {
					if(self.signoffFrom && self.signoffFrom.id === selection.id){
						self.signoffFrom = null;
					} else {
						self.signoffFrom = selection;
					}
					self.$store.commit("closeModal");
				},
				selected: [{
					id: (this.signoffFrom?this.signoffFrom.id:null)
				}],
				data: this.signers,
				captionKey: 'title'
			});
		},
		openWorkbooksModal() {
			const self = this
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select-workbooks'),
				selectCallback: function(selection) {
					const isSelected = self.workbooks.find(
						(workbook, i) => {
							if(workbook.id === selection.id){
								self.$delete(self.workbooks, i);
								return true;
							}
						}
					);
					if (!isSelected) {
						self.workbooks.push(selection);
					}
				},
				selected: this.workbooks,
				data: this.$config.getValue('workbooks'),
				captionKey: 'title'
			});
		},
	},
};
</script>
